import { mapState } from "vuex";
import Vue from "vue";

Vue.mixin({
  methods: {
    scrollToInvalidInput(inputs) {
      const inputError = inputs.find((input) => input.hasError);
      if (inputError) {
        const el = inputError.$el;
        const y =
          el.getBoundingClientRect().top +
          window.scrollY -
          document.querySelector(".app-bar")?.offsetHeight -
          20;

        window.scroll({
          top: y,
          behavior: "smooth",
        });
      }
    },
    async $confirmWindow({ title, description }) {
      return new Promise((resolve) => {
        this.$root.$emit("confirmDialog", {
          title,
          description,
          callback: (value) => {
            resolve(value);
          },
        });
      });
    },

    // DEPRECATED (has a typo). Here for backwards
    // compatibility. Use $alertWindow instead.
    $allertWindow(message, type = "success") {
      this.$root.$emit("alert", {
        message,
        type,
      });
    },

    $alertWindow(message, type = "success") {
      this.$root.$emit("alert", {
        message,
        type,
      });
    },

    // Check the current admin's active project slug from any component,
    // e.g. `this.$isProjectSlug("EVERY2501")` or
    // `this.$isProjectSlug("EVERY2302", "EVERY2501")` for several at once.
    // Replaces one-off `currentUser.active_project.slug == '...'` checks.
    $isProjectSlug(...slugs) {
      return slugs.includes(this.currentUser?.active_project?.slug);
    },
  },
  computed: {
    ...mapState({
      authToken: (state) => state.auth.token,
      currentUser: (state) => state.user.current,
      datasources: (state) => state.datasources.data,
      envAgnostic: (state) => state.ui.envAgnostic,
    }),
    activeProject() {
      return this.currentUser?.active_project;
    },
    $size() {
      return this.$vuetify.breakpoint.name;
    },
  },
});
